import React from 'react'
import "./style.css";

const Footer = ({children}) => {
  return (
    <footer className="container">{children}</footer>
  )
};

export default Footer;